import { render } from "./top-nav.vue?vue&type=template&id=3a8bcbf5&scoped=true"
import script from "./top-nav.vue?vue&type=script&setup=true&lang=js"
export * from "./top-nav.vue?vue&type=script&setup=true&lang=js"

import "./top-nav.vue?vue&type=style&index=0&id=3a8bcbf5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8bcbf5"],['__file',"src/Global/components/top-nav.vue"]])

import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QList,QItem,QItemSection,QHeader,QToolbar,QBtn,QTabs,QRouteTab,QSpace,QAvatar,QMenu,QTab});
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a8bcbf5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a8bcbf5', __exports__)) {
    api.reload('3a8bcbf5', __exports__)
  }
  
  module.hot.accept("./top-nav.vue?vue&type=template&id=3a8bcbf5&scoped=true", () => {
    api.rerender('3a8bcbf5', render)
  })

}


export default __exports__